export const SEPARATOR = '%%%';
export const KEY_REGEX = /^[a-zA-Z0-9_-]*$/;

export const BACKOFFICE_TIMEZONES = [{ label: 'UTC', value: 'utc' }];
